import axios from 'axios';
import { getCookieValues } from '../../utilities/helpers';
import { bbSubDomain } from '../../utilities/UrlPaths';

const [houseUserName] = getCookieValues(['HOUSEALIAS']);

const baseURL = `https://${bbSubDomain()}.invaluable.com/`;

const baseConfig = {
  baseURL: `${baseURL}api/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    houseUserName
  }
};

const customRequest = axios.create(baseConfig);

export const customRequestApp = axios.create({
  ...baseConfig,
  headers: {
    ...baseConfig.headers,
    channel: 'infinitebidding',
  },
  baseURL,
});

export default customRequest;
